import { sectionHeader } from './index';

export const information = (bid) => {
  const result = [];
  const {
    showBasic,
    showIntroduction,
    showSituation
  } = bid.template.sales;

  if (showBasic || showIntroduction || showSituation) {
    result.push(sectionHeader("Information"));
  }

  if (showBasic) {
    result.push(getBasic(bid));
  }

  if (showIntroduction) {
    result.push(getIntroduction(bid));
  }

  if (showSituation) {
    result.push(getSituation(bid));
  }

  result.push({
    style: "sectionFooter",
    text: "",
  });

  return result;
};

const getBasic = (bid) => ({
  alignment: 'justify',
  margin: [2, 0, 0, 0],
  columns: [
    {
        stack: [
            { text: "Contact", style: "label" },
            { text: bid.contact ? bid.contact : "" },
            { text: "", margin: [0, 0, 0, 10] },
        ]
    },
    {
        stack: [
            { text: "Job Code", style: "label" },
            { text: bid.code ? bid.code : "" },
        ]
    }
  ]
});

const getIntroduction = (bid) => ({
  margin: [2, 0, 0, 0],
  stack: [
      { text: "Introduction", style: "label" },
      { text: bid.introduction ? bid.introduction : "" },
      { text: "", margin: [0, 0, 0, 10] }
  ]
});

const getSituation = (bid) => ([
  {
    margin: [2, 0, 0, 0],
    stack: [
        { text: "Situation", style: "label" },
        { text: bid.situation ? bid.situation : "" },
        { text: "", margin: [0, 0, 0, 10] },
    ]
  },
  {
    margin: [2, 0, 0, 0],
    stack: [
        { text: "Solution", style: "label" },
        { text: bid.solution ? bid.solution : "" }
    ]
  }
]);



// WEBPACK FOOTER //
// ./src/store/generators/PDF/bid/information.js